import { moduleProviderFactory } from 'core/providers';
import { PublicLayout } from 'core/layouts';
import { ChannelList, ChannelEdit, WalmartConnect, WalmartConnected } from 'modules/channel/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				// Public: /walmart/connect is where a seller who arrived from Seller Center picks the
				// channel to authorize, and the Auth Callback redirects the browser to
				// /walmart/connected. Neither may require an existing session.
				name: 'master.app.walmart',
				pattern: '/walmart',
				component: [PublicLayout],
				children: [
					{
						name: 'master.app.walmart.connect',
						pattern: '/connect',
						component: WalmartConnect,
					},
					{
						name: 'master.app.walmart.connected',
						pattern: '/connected',
						component: WalmartConnected,
					},
				],
			},
			{
				name: 'master.app.main.channel',
				pattern: '/channels',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.channel.list',
						pattern: '',
						authorization: 'channelSection.full',
						component: ChannelList,
					},
					{
						name: 'master.app.main.channel.add',
						pattern: '/add',
						authorization: 'channelSection.full',
						component: ChannelEdit,
					},
					{
						name: 'master.app.main.channel.edit',
						pattern: '/edit/:id',
						authorization: 'channelSection.full',
						component: ChannelEdit,
					},
				],
			},
		],
	});
})();
